import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Paper,
  useMediaQuery,
  Box,
  Modal,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import {
  BarcodeScanningDelete_GETROW,
  BarcodeScanningGetRow_GETROW,
} from "../../../Server/ApiV2";

import DeleteIcon from "@mui/icons-material/Delete";
import { BarcodeScanningRo } from "../../../Redux/roStore";
const ViewListModal = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "View List", 
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [virwRows, setViewRows] = useState([]);

  const handleDelete = async (row) => {
    let{Head}=BarcodeScanningRo()
    const payload = {
      v_UId: Head.SheetNo,
      v_Barcode: row.Barcode,
      v_Typ: row.Type,
    };
    let resp = await BarcodeScanningDelete_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      handleLoad();
    }
  };

  const handleLoad = async () => {
    let{Head}=BarcodeScanningRo()
    const payload = {
      v_UId: Head.SheetNo,
    };
    let resp = await BarcodeScanningGetRow_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData = resp?.data?.ResultSet;

      setViewRows(respData);
    } else {
      setViewRows([]);
    }
  };
  useEffect(() => {
    if (open) {
      handleLoad();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setViewRows([]);
        fCloseSearchModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky
            title={xTitle}
            onClose={() => {
              setViewRows([]);
              fCloseSearchModal();
            }}
          />

          <Box style={{ padding: "20px" }}>
            <Grid
              container
              spacing={1}
              marginY={"5px"}
              // height={"78vh"}
              // sx={{ overflowY: "scroll", height: { md: "78vh", xs: "58vh" } }}
            >
              {virwRows.map((row, index) => (
                <Grid item xs={12} sm={6} md={6} key={row.id}>
                  <Box
                    sx={{
                      border: 1,
                      borderColor: "primary.main",
                      borderRadius: "6px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      // height: "100%",
                      padding: "10px",
                    }}
                  >
                    <>
                      <Grid container spacing={0.1} alignItems={"center"}>
                        <Grid item xs={4} md={3}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            Barcode
                          </Typography>
                        </Grid>
                        <Grid item xs={8} md={9}>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            {row.Barcode}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} md={3}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            Type
                          </Typography>
                        </Grid>
                        <Grid item xs={8} md={9}>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            {row.Type}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} md={3}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            Unit
                          </Typography>
                        </Grid>
                        <Grid item xs={8} md={9}>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            {row.Unit}
                          </Typography>
                        </Grid>
                        
                        <Grid item xs={4} md={3}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            Qty
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          md={9}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            {row.Qty}
                          </Typography>
                          <IconButton
                            color="primary"
                            onClick={() => handleDelete(row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                        <Grid item xs={4} md={3}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              color: "primary.main",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            ItemName
                          </Typography>
                        </Grid>
                        <Grid item xs={8} md={9}>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: {
                                md: "15px !important",
                                sm: "14px !important",
                                xs: "12px",
                              },
                            }}
                          >
                            {row.ItemName}
                          </Typography>
                        </Grid>

                      </Grid>
                    </>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default ViewListModal;
